export default __webpack_public_path__ + "static/media/OrderTagTwo.85333c12.png";